<template>
    <div>
        <FindMemberIds/>
        <BasicStatisticsRow basicstatisticspath="/2.0/newbe/statistics/surrogates?sessionid="/>
    </div>
</template>

<script>
import FindMemberIds from '../components/FindMemberIds.vue';

export default {
    name: "ManageMemberIds",
  components: {
    FindMemberIds,
  },
}
</script>